import React from 'react';

import type {IconProps} from '../types';
import {colourMap, sizesMap} from '../utils/iconProperties';

const GlobeIcon = ({
  size = 'small',
  colour = 'textPrimary',
  alt,
}: IconProps): JSX.Element => (
  <svg
    aria-hidden={!alt ? true : undefined}
    aria-label={alt}
    role={alt ? 'img' : undefined}
    width={sizesMap[size]}
    height={sizesMap[size]}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={colourMap[colour]}
      d='M11.988 0C5.364 0 0 5.376 0 12s5.364 12 11.988 12C18.624 24 24 18.624 24 12S18.624 0 11.988 0Zm8.316 7.2h-3.54c-.384-1.5-.936-2.94-1.656-4.272A9.636 9.636 0 0 1 20.304 7.2ZM12 2.448A16.904 16.904 0 0 1 14.292 7.2H9.708A16.904 16.904 0 0 1 12 2.448ZM2.712 14.4A9.89 9.89 0 0 1 2.4 12c0-.828.12-1.632.312-2.4h4.056A19.818 19.818 0 0 0 6.6 12c0 .816.072 1.608.168 2.4H2.712Zm.984 2.4h3.54c.384 1.5.936 2.94 1.656 4.272A9.584 9.584 0 0 1 3.696 16.8Zm3.54-9.6h-3.54a9.584 9.584 0 0 1 5.196-4.272A18.779 18.779 0 0 0 7.236 7.2ZM12 21.552A16.904 16.904 0 0 1 9.708 16.8h4.584A16.904 16.904 0 0 1 12 21.552Zm2.808-7.152H9.192C9.084 13.608 9 12.816 9 12c0-.816.084-1.62.192-2.4h5.616c.108.78.192 1.584.192 2.4 0 .816-.084 1.608-.192 2.4Zm.3 6.672a18.779 18.779 0 0 0 1.656-4.272h3.54a9.636 9.636 0 0 1-5.196 4.272Zm2.124-6.672c.096-.792.168-1.584.168-2.4 0-.816-.072-1.608-.168-2.4h4.056A9.89 9.89 0 0 1 21.6 12a9.89 9.89 0 0 1-.312 2.4h-4.056Z'
    />
  </svg>
);

export default GlobeIcon;
